import { render, staticRenderFns } from "./CGA.vue?vue&type=template&id=6a98bdcd&scoped=true&"
import script from "./CGA.vue?vue&type=script&lang=js&"
export * from "./CGA.vue?vue&type=script&lang=js&"
import style0 from "./CGA.vue?vue&type=style&index=0&id=6a98bdcd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a98bdcd",
  null
  
)

export default component.exports